import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@blueprintjs/core'
import Icon from 'images/demo/failed.svg'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const PaymentFailedPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.DemoPage)

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex flex-col items-center gap-12">
        <div className="flex h-30 w-30 items-center justify-center rounded-half bg-surface-gray">
          <img src={Icon} className="" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <Text tagName="span" className="font-tertiary-semibold---27pt text-functional-error-alt">
            {t('failed.title')}
          </Text>
          <Text tagName="span" className="font-tertiary-regular---14pt text-text-gray">
            {t('failed.caption')}
          </Text>
        </div>
      </div>
    </div>
  )
}

export { PaymentFailedPageContent }
